import React from 'react';
import Button from '../components/Buttons/Button';

interface LaunchPartnerProps {
  alignmentClasses: string;
}

const LaunchPartner: React.FC<LaunchPartnerProps> = ({ alignmentClasses }) => {
  const handleRegisterClick = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSdL_qHP46e1wtmBttDlSGlLDLhP56wNsYws1gAKLUK5HXWOHQ/viewform?usp=sharing', '_blank');
  };

  return (
    <section className={`${alignmentClasses} py-12 md:py-20`}>
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="h2 mb-4 text-2xl font-extrabold">Want to join us as a launch partner?</h2>
        <p className="text-xl text-muted-black mb-8 font-noto">
          We're seeking passionate launch partners to kick off our site. As a launch partner, your events will receive promotion on our site and social media channels.
        </p>
        <Button onClick={handleRegisterClick}>
          Register your interest
        </Button>
      </div>
    </section>
  );
};

export default LaunchPartner; 